// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconLinearMap = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 16 17',
      fill: 'none',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M1.52637 5.68661V12.1733C1.52637 13.4399 2.42637 13.9599 3.5197 13.3333L5.08637 12.4399C5.42637 12.2466 5.99303 12.2266 6.34637 12.4066L9.84637 14.1599C10.1997 14.3333 10.7664 14.3199 11.1064 14.1266L13.993 12.4733C14.3597 12.2599 14.6664 11.7399 14.6664 11.3133V4.82661C14.6664 3.55994 13.7664 3.03994 12.673 3.66661L11.1064 4.55994C10.7664 4.75328 10.1997 4.77328 9.84637 4.59328L6.34637 2.84661C5.99303 2.67328 5.42637 2.68661 5.08637 2.87994L2.1997 4.53328C1.82637 4.74661 1.52637 5.26661 1.52637 5.68661Z',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.70605 3.16663V11.8333',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.4873 4.91333V13.8333',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
  );

export { IconLinearMap };
